import React from "react";
import { Download } from "lucide-react";
import { cn } from "@/lib/utils";

type DownloadIconLinkProps = {
  href: string;
  ariaLabel: string;
  className?: string;
  iconClassName?: string;
};

export default function DownloadIconLink({
  href,
  ariaLabel,
  className,
  iconClassName,
}: DownloadIconLinkProps) {
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={ariaLabel}
      className={cn(
        "inline-flex items-center justify-center p-1 text-[#4285F4] hover:text-[#4285F4]",
        className,
      )}
    >
      <Download className={cn("w-5 h-5", iconClassName)} />
    </a>
  );
}
